
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 16, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

export default {
	title: "Weight",
	description: "glucose.manual_entry",
	type: "object",
	properties: {
		kg: {
			type: "number",
			description: "weight.weightdescriptionkg",
			placeholder: "weight.messagekg",
			minimum: 1,
			maximum: 400
		},
		comment: {
			description: "weight.commenttitle",
			type: "string",
			multiline: true,
			placeholder: "weight.comment"
		}
	},
	required: ["kg"]
};
